import React from "react";
import ResetPassword from "./ResetPassword";
import ResetPasswordIllustration from "./ResetPasswordIllustration";

const ResetPasswordPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row" id="reset-password-page-container">
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 sm:px-12 py-12 lg:py-0" id="reset-password-page-content-container">
        <ResetPassword />
      </div>

      <div className="hidden lg:flex lg:w-1/2 bg-[#E8F0FF] items-center justify-center" id="reset-password-page-illustration-container">
        <ResetPasswordIllustration />
      </div>
    </div>
  );
};

export default ResetPasswordPage;

